import React from "react";
import ExamPanel from "./ExamPanel";

export default function KeyBoardCheckPage() {
  return (
    <ExamPanel
      eyebrow="System check"
      title="Keyboard Check"
      instructions={[
        "This is an opportunity to check that you have the correct keyboard.",
        "Look at the top row of letters. They should appear in this order: Q W E R T Y.",
        "If you do not have a QWERTY keyboard, raise your hand to get assistance.",
      ]}
    >
      <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
        <img
          className="mx-auto max-h-[340px] w-full max-w-4xl rounded-md object-contain"
          src="/image/keyboard.jpg"
          alt="QWERTY keyboard"
        />
      </div>
    </ExamPanel>
  );
}
